/**
 *
 * Common form classNames for BC ATC BD/GD(14140)
 *
 */

export const helperTextClassName = 'BC_Berlinsky_Genevsky-14140-advanced-form-field-helper-text';
